import React from "react";

function SignupStepMarker({ active = 1, phrase }) {
  return (
    <ul>
      <li
        className={`step ${
          active === 1 ? "active" : active > 1 ? "completed" : ""
        }`}
      >
        {active === 1 ? phrase : "1"}
      </li>
      <li
        className={`step ${
          active === 2 ? "active" : active > 2 ? "completed" : ""
        }`}
      >
        {active === 2 ? phrase : "2"}
      </li>
      <li
        className={`step ${
          active === 3 ? "active" : active > 3 ? "completed" : ""
        }`}
      >
        {active === 3 ? phrase : "3"}
      </li>
      <li
        className={`step ${
          active === 4 ? "active" : active > 4 ? "completed" : ""
        }`}
      >
        {active === 4 ? phrase : "4"}
        <div
          className={`step ${
            active === 5 ? "active" : active > 5 ? "completed" : ""
          }`}
        />
      </li>
    </ul>
  );
}

export default SignupStepMarker;
